import { useMemo, useState } from 'react'
import { essaysV6 as expeditionEssays, editorialLines } from '../data/expedition-v6.js'
import { useExpedition } from '../store/useExpedition.js'

const order=['craft','laws','people','portfolio','place','culture']
export function FieldIndex({ onChoose }) {
  const close=useExpedition(state=>state.closeIndex)
  const read=useExpedition(state=>state.readEssayIds)
  const [query,setQuery]=useState('')
  const [line,setLine]=useState('all')
  const results=useMemo(()=>{
    const q=query.trim().toLowerCase()
    return expeditionEssays.filter(essay=>(line==='all'||essay.theme===line)&&(!q||`${essay.title} ${essay.takeaway} ${essay.date} ${(essay.tags||[]).join(' ')} ${(essay.entities||[]).join(' ')}`.toLowerCase().includes(q)))
  },[query,line])
  return <aside className="field-index" aria-label="Perspectives field index">
    <header><div><span>FIELD INDEX</span><strong>55 notes from the route</strong></div><button onClick={close}>×</button></header>
    <input autoFocus value={query} onChange={event=>setQuery(event.target.value)} placeholder="Search people, principles, places…"/>
    <nav><button className={line==='all'?'active':''} onClick={()=>setLine('all')}>All · 55</button>{order.map(id=><button key={id} className={line===id?'active':''} onClick={()=>setLine(id)}>{editorialLines[id].name}</button>)}</nav>
    <div className="field-results">{results.map(essay=><button key={essay.id} onClick={()=>onChoose(essay.index)}><i className={read.includes(essay.id)?'read':''}></i><span><small>{essay.date} · {editorialLines[essay.theme].name}</small><strong>{essay.title}</strong><em>{essay.takeaway}</em></span><b>↗</b></button>)}</div>
    <footer>{read.length} / 55 field notes visited</footer>
  </aside>
}
